export const SET_HRES6EU_INDEX_DISP = 'SET_HRES6EU_INDEX_DISP'
export const GET_HRES6EU_INDEX_DISP = 'GET_HRES6EU_INDEX_DISP'
export const SET_HRES6EU_DETAIL_DISP = 'SET_HRES6EU_DETAIL_DISP'
export const GET_HRES6EU_DETAIL_DISP = 'GET_HRES6EU_DETAIL_DISP'
export const GET_HRES6EU_MAX_ROWSPAN = 'GET_HRES6EU_MAX_ROWSPAN'
export const SET_HRES6EU_COLUMNS = 'SET_HRES6EU_COLUMNS'
export const GET_HRES6EU_COLUMNS = 'GET_HRES6EU_COLUMNS'
export const SET_HRES6EU_LABELS = 'SET_HRES6EU_LABELS'
export const GET_HRES6EU_LABELS = 'GET_HRES6EU_LABELS'
export const RECEIVED_HRES6EU_COLUMNS_LABELS = 'RECEIVED_HRES6EU_COLUMNS_LABELS'
export const SET_HRES6EU_INDEX = 'SET_HRES6EU_INDEX'
export const GET_HRES6EU_INDEX = 'GET_HRES6EU_INDEX'
export const RECEIVED_HRES6EU_INDEX = 'RECEIVED_HRES6EU_INDEX'
export const SET_HRES6EU_INDEX_SELECTED = 'SET_HRES6EU_INDEX_SELECTED'
export const GET_HRES6EU_INDEX_SELECTED = 'GET_HRES6EU_INDEX_SELECTED'
export const SET_HRES6EU_DETAIL = 'SET_HRES6EU_DETAIL'
export const GET_HRES6EU_DETAIL = 'GET_HRES6EU_DETAIL'
export const RECEIVED_HRES6EU_DETAIL = 'RECEIVED_HRES6EU_DETAIL'
export const TOGGLE_HRES6EU_PAGE = 'TOGGLE_HRES6EU_PAGE'
export const POST_HRES6EU_SEND_APPROVE = 'POST_HRES6EU_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres6eu/mutation-types.js